var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-tippy"},[_c('span',{ref:"target",staticClass:"target",on:{"click":_vm.onClick}},[_vm._t("target")],2),_c('span',{ref:"content",staticClass:"content"},[(!_vm.lazyView || _vm.shown)?_vm._t("content"):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }